// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__4FGqi","wrapper":"styles_wrapper__yiULw","content":"styles_content__wupWL","title":"styles_title__bbuIw","description":"styles_description__X3NtK"};